import { render } from "./Anfrage.vue?vue&type=template&id=47f003f1"
import script from "./Anfrage.vue?vue&type=script&lang=js"
export * from "./Anfrage.vue?vue&type=script&lang=js"

import "./Anfrage.vue?vue&type=style&index=0&id=47f003f1&lang=css"
script.render = render

export default script